import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'reviews';
export const reviewsActions = makeActions(MODEL_NAME);

export const getAllReviews = reviewsActions.getAll;
export const editReviews = reviewsActions.edit;
export const createReviews = reviewsActions.create;
export const getByIdReviews = reviewsActions.getDataById;
